import React, { useEffect, useState, useMemo } from 'react'
import userHasPrivs from 'Helper/Auth/userHasPrivs'
import { useSelector, useDispatch } from 'react-redux'
import { xtractAPI } from 'actions/apiActions'
import { openModal } from 'actions/modalActions'
import SearchList from 'GeneralUI/SearchList/SearchList.jsx'
import ModifyButtons from 'GeneralUI/ModifyButtons/ModifyButtons.jsx'
import InputGroupText from 'GeneralUI/inputGroupText/InputGroupText.jsx'
import Loading from 'GeneralUI/Loading/Loading.jsx'
import SettingsTitle from 'GeneralUI/SettingsTitle/SettingsTitle.jsx'
import StandardModalContent from 'GeneralUI/StandardModalContent/StandardModalContent.jsx'
import { getDefaultCallbacks } from 'Helper/apiHelper'
import { _ } from 'core-js'

const AttachmentTags = () => {

    const [item, setItem] = useState(null)
    const [originalItem, setOriginalItem] = useState(null)
    const [loading, setLoading] = useState(false)
    const [allOrderedItems, setAllOrderedItems] = useState([])
    const [nameToSelect, setNameToSelect] = useState(null)

    const dispatch = useDispatch()

    // privileges
    const manageTagsPriv = userHasPrivs('manage_attachment_tags')
    const manageTagsTooltip =
        'The Manage Attachment Tags privilege within General Tab is required to perform this action'

    const itemIdString = 'attachment_tag_id'
    const attachmentTags = useSelector(state => state.appConfig?.attachmentTags) || []

    const nextPosition = useMemo(() => {
        if(Array.isArray(allOrderedItems) && allOrderedItems.length > 0) {
            const lastPosition = allOrderedItems.reduce((prev, current) => {
                return Math.max(prev, current.position)
            }, 0)
            return lastPosition + 1
        } else {
            return 0
        }
    },[allOrderedItems])

    useEffect(() => {
        getOrderedItems()
    }, [])

    useEffect(() => {
        const allItems = attachmentTags.sort(
            (a, b) => a.position - b.position
          )
        setAllOrderedItems(allItems)
    }, [attachmentTags])

    useEffect(() => {
        if (nameToSelect) {
            const target = allOrderedItems.find(
                item => item.name === nameToSelect
            )
            setNameToSelect(null)
            if (
                target != null &&
                target[itemIdString] != null
            ) {
                setOriginalItem(target)
            } else {
                setItem(newItem(allOrderedItems))
                setOriginalItem(newItem(allOrderedItems))
            }
        }
    }, [allOrderedItems])

    const getOrderedItems = (nameToSelect = null) => {
        setLoading(true)
        const callbacks = {
            ...getDefaultCallbacks(() => {
                setLoading(false)
            }),
            200: () => {
                setLoading(false)
                setNameToSelect(nameToSelect)
            }
        }
        dispatch(
            xtractAPI(
                'attachment_tag',
                'read',
                null,
                callbacks
            )
        )
    }
    const selectItem = item => {
        if (
            item != null
        ) {
            setItem(item)
            setOriginalItem(item)
        }
    }
    const showItemDetails = () => {
        if (item === null || (item?.name === 'New Item' && !manageTagsPriv)) {
            const message = item?.name === 'New Item' && !manageTagsPriv ? manageTagsTooltip : "Please select an item"
            return (
                <div className="account-details">
                    <div
                        style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        {message}
                    </div>
                </div>
            )
        } else {
            return (
                <div className="statuses-details">
                    <div className="settings-item well" style={{ width: '60%' }}>
                        <SettingsTitle value="Tag Name" htmlFor="item-name" />
                        <InputGroupText
                            id="item-name"
                            style={{ border: '1px solid lightgrey' }}
                            type="text"
                            placeholder="Name"
                            aria-label="item input"
                            value={item.name || ''}
                            title={''}
                            onChange={e => {
                                setItem({
                                    ...item,
                                    name: e.target.value
                                })
                            }}
                            disabled={!manageTagsPriv}
                            data-toggle={manageTagsPriv ? null : 'tooltip'}
                            data-title={manageTagsTooltip}
                            data-placement="bottom"
                        />
                        <SettingsTitle value="Tag Position" htmlFor="item-position" />
                        <div id="item-position">
                            <InputGroupText
                                id="item-position"
                                style={{ border: '1px solid lightgrey' }}
                                type="number"
                                placeholder="Position"
                                aria-label="position input"
                                value={item.position || nextPosition}
                                title={''}
                                onChange={e => {
                                    const value = e.target.value
                                    setItem({
                                        ...item,
                                        position: value
                                    })
                                }}
                                disabled={!manageTagsPriv}
                                data-toggle={manageTagsPriv ? null : 'tooltip'}
                                data-title={manageTagsTooltip}
                                data-placement="bottom"
                            />
                        </div>
                    </div>
                    {item[itemIdString] !== 0
                        ? (
                            <p style={{ marginLeft: '5px' }}>
                                <strong style={{ color: 'var(--red-color)' }}>Note: </strong>
                                Changing the name of a item will affect all records using that
                                item.
                            </p>
                        )
                        : null}
                </div>
            )
        }
    }
    const clearItem = () => {
        setItem(null)
    }
    const newItem = (allOrderedItems) => {
        const item = {
            name: '',
            position: nextPosition
        }
        item[itemIdString] = 0

        return item
    }
    const confirmDeleteItem = () => {
        dispatch(
            openModal('confirm-delete-item', {
                title: 'Confirm Delete',
                content: (
                    <StandardModalContent
                        messageContent={
                            <div style={{ marginBottom: '25px' }}>
                                Are you sure that you want to delete this item (
                                {item.name})?
                            </div>
                        }
                        okHandler={() => deleteItem()}
                        okClassName={'btn-danger'}
                        okText={'Delete'}
                        cancelHandler={() => { }}
                        cancelText={'Cancel'}
                        cancelClassName={'btn-success'}
                    />
                ),
                closeable: true
            })
        )
    }
    const deleteItem = () => {
        const selectedId = item[itemIdString]
        const callbacks = {
            ...getDefaultCallbacks(() => {
                setLoading(false)
            }),
            200: () => {
                clearItem()
                setItem(null)
                getOrderedItems()
            }
        }
        setLoading(true)
        dispatch(
            xtractAPI(
                'attachment_tag/' + selectedId,
                'delete',
                null,
                callbacks
            )
        )
    }
    const saveItem = () => {
        const selectedId = item[itemIdString]
        const itemToSave = item

        const updatedItem = { ...itemToSave }

        if (itemToSave.name !== '') {
            const callbacks = {
                ...getDefaultCallbacks(() => {
                    setLoading(false)
                }),
                200: result => {
                    getOrderedItems(result.data.data.attachment_tag.name)
                }
            }
            setLoading(true)
            if (selectedId) {
                dispatch(
                    xtractAPI(
                        'attachment_tag/' +
                        itemToSave[itemIdString],
                        'update',
                        updatedItem,
                        callbacks
                    )
                )
            } else {
                if(isNaN(parseInt(item?.position))){
                    item.position = nextPosition
                }
                dispatch(
                    xtractAPI(
                        'attachment_tag',
                        'create',
                        item,
                        callbacks
                    )
                )
            }
        }
    }

    if (!allOrderedItems || loading) {
        return <Loading />
    } else {
        const selectedId =
        item === null ? null : item[itemIdString]

        const changed = item &&
            (item.name !== originalItem.name ||
                (item && item.position !== originalItem.position))

        const newItemName = 'New Item'

        const isNewItem = item && item[itemIdString] === 0

        const newItem = { name: newItemName, position: '' }
        newItem[itemIdString] = 0
        
        return (
            <div className="statuses-management">
                <div className="statuses-container">
                    <div className="statuses-search">
                        <SearchList
                            selected={
                                item === null
                                    ? null
                                    : selectedId > 0
                                ? item
                                : newItem
                            }
                            newObject={newItem}
                            columns={[
                                {
                                    header: 'Tag Name',
                                    id: 'name'
                                },
                                {
                                    header: 'Position',
                                    id: 'position'
                                }
                            ]}
                            data={allOrderedItems}
                            clickHandler={selectItem}
                            style={{
                                position: 'relative',
                                fontSize: '18px',
                                padding: '10px'
                            }}
                            placeholder={
                                'Search Attachment Tags'
                            }
                            alwaysShowList={true}
                            clearOnSelect={true}
                        />
                    </div>
                    {showItemDetails()}
                </div>
                <div className="bottom-buttons">
                    <ModifyButtons
                        showCancel={selectedId != null}
                        cancelHandler={clearItem}
                        showUpdate={changed && selectedId != null && !isNewItem}
                        updateHandler={saveItem}
                        showSaveNew={isNewItem && changed}
                        saveNewHandler={saveItem}
                        saveNewDisabled={!manageTagsPriv}
                        saveNewDataToggle={manageTagsPriv ? null : 'tooltip'}
                        saveNewDataTitle={manageTagsTooltip}
                        showDelete={selectedId !== null && !isNewItem}
                        deleteHandler={confirmDeleteItem}
                        deleteDisabled={!manageTagsPriv}
                        deleteDataToggle={manageTagsPriv ? null : 'tooltip'}
                        deleteDataTitle={manageTagsTooltip}
                    />
                </div>
            </div>
        )
    }
}

export default AttachmentTags
